import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changeset from 'ember-changeset/helpers/changeset';
import t from 'ember-intl/helpers/t';
import add from 'ember-math-helpers/helpers/add';
import ModelList from 'parog-web/components/model-list';
import type FollowUpReason from 'parog-web/models/follow-up-reason';
import Dropdown from 'ui-kit/components/changeset/dropdown';
import DatePicker from '../../changeset/date-picker';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    followUpReasonId: FollowUpReason['id'];
  };
}
export default class TreatmentHistoryEditionFormBreastCancerFormTargetedTherapySection extends Component<Signature> {
  get targetedTherapyTypes(): string[] {
    switch (this.args.followUpReasonId) {
      case 'onco-pancreatic-cancer':
        return [
          'olaparib-300',
          'olaparib-250',
          'olaparib-200',
          'olaparib-150',
          'olaparib-100'
        ];
      default:
        return ['herceptin', 'avastin', 'perjeta', 'kadcyla', 'tyverb'];
    }
  }

  get #targetedTherapies() {
    return this.args.changeset.get('targeted-therapies');
  }

  onChangesetUpdate = (changeset: EmberChangeset) => {
    changeset.execute();
    this.#setAsDirty();
  };

  #setAsDirty() {
    this.args.changeset.set(
      'targeted-therapies',
      [].concat(this.#targetedTherapies)
    );
  }

  <template>
    <h2 class='ui dividing header'>Thérapie ciblée</h2>

    <div class='field'>
      <div class='field' id='targetedTherapies' data-test-targeted-therapy-list>
        <ModelList
          @model={{@changeset}}
          @propertyName='targetedTherapies'
          @addButtonTitle='Ajouter une thérapie ciblée'
          as |Item|
        >
          {{#let (changeset Item.item) as |targetedTherapyChangeset|}}
            <div
              class='ui segment'
              data-test-targeted-therapy-list-item={{Item.index}}
            >
              <h3 class='ui dividing header'>Thérapie ciblée
                {{add Item.index 1}}</h3>
              <i
                class='trash icon absolute right-0 top-0 m-2 opacity-[0.5]'
                role='button'
                {{on 'click' Item.destroy}}
              >
              </i>

              <div class='field'>
                <DatePicker
                  @labelName='Date de début'
                  @propertyName='startDate'
                  @changeset={{targetedTherapyChangeset}}
                  @onChangesetUpdate={{this.onChangesetUpdate}}
                />
              </div>
              <div class='field'>
                <DatePicker
                  @labelName='Date de fin'
                  @propertyName='endDate'
                  @changeset={{targetedTherapyChangeset}}
                  @onChangesetUpdate={{this.onChangesetUpdate}}
                />
              </div>
              <div class='field'>
                <Dropdown
                  @labelName='Type de thérapie ciblée'
                  @changeset={{targetedTherapyChangeset}}
                  @onChangesetUpdate={{this.onChangesetUpdate}}
                  @propertyName='type'
                  @multipleSelection={{true}}
                  as |dropdown|
                >
                  {{#each this.targetedTherapyTypes as |targetedTherapyType|}}
                    <dropdown.Item
                      @key={{targetedTherapyType}}
                      @value={{t
                        (concat 'targeted-therapy-type.' targetedTherapyType)
                      }}
                    />
                  {{/each}}
                </Dropdown>
              </div>
            </div>
          {{/let}}
        </ModelList>
      </div>
    </div>
  </template>
}
